module.exports = __webpack_public_path__ + "img/marker_selected_no_image.43585b54.svg";